import axios from 'axios'

axios.defaults.withCredentials = true

export default {
    state : { 
        baseUrl:process.env.API_URL,
        organization:{},
        user:{},
        users:[],
        organizationCustomFields:[]
    },
    getters : {
        organization:(state)=>{
            return state.organization
        },
        user:(state)=>{
            return state.user
        },
        users:(state)=>{
            return state.users
        },
        organizationCustomFields:(state)=>{
            return state.organizationCustomFields
        }
    },
    mutations : { 
        organization(state,organization){
            state.organization = organization
        },
        user(state,user){
            state.user = user
        },
        users(state,users){
            state.users = users
        },
        organizationCustomFields(state,organizationCustomFields){
            state.organizationCustomFields = organizationCustomFields
        }
    },
    actions : { 
        getOrganization({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getOrganization`,form)
                .then(response => {
                    if(response.data.status.code==0){
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        updateOrganizations({state},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateOrganizations`,form)
                .then(response => {
                    console.log("updateOrganizations action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        relateContactToOrganization({state},form){
            
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/addOrganizationContact`,form)
                .then(response => {
                    console.log("addOrganizationContact action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
        },
        removeOrganizationContact({state},form){
            
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/removeOrganizationContact`,form)
                .then(response => {
                    console.log("removeOrganizationContact action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
        },
        deleteOrganizations({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/deleteOrganizations`,form)
                .then(response => {
                    console.log("deleteOrganizations action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        /*
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                        */
                       resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        }
    }
}